import { render, staticRenderFns } from "./Opencart.vue?vue&type=template&id=5092ff1c&scoped=true"
import script from "./Opencart.vue?vue&type=script&lang=js"
export * from "./Opencart.vue?vue&type=script&lang=js"
import style0 from "./Opencart.vue?vue&type=style&index=0&id=5092ff1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5092ff1c",
  null
  
)

export default component.exports